import { useContext, useEffect } from 'react';
import { GridApi } from 'ag-grid-community';

import CardContext from '../../../contexts/CardContext';
import ReportContext from '../../../contexts/ReportContext';
import useGridCsvExport from './useGridCsvExport';

// Registers a grid gadget's CSV export callback for the scheduled-report PDF
// export, WITHOUT needing the export ContextMenu to be opened. Matrix gadgets
// only mount their ExportButton (which does the registration) inside a menu
// popover, so during a headless render — where nobody opens the menu — their
// CSV callback would never register and no CSV would be attached. Mounting this
// alongside the grid fills that gap. Gated on `isPdfExport`, so it is a full
// no-op in interactive views and on wallboards. Renders nothing.
const GridCsvExportRegistrar = ({
  overrideGridApi,
  exportHandle,
  exportName,
}: {
  overrideGridApi?: GridApi;
  exportHandle?: DataTable.ExportHandle;
  exportName?: string;
}) => {
  const { i } = useContext(CardContext);
  const { isPdfExport, setGridExportCallbacks } = useContext(ReportContext);
  const { exportDataAsCsv } = useGridCsvExport({
    overrideGridApi,
    exportHandle,
    exportName,
  });

  useEffect(() => {
    if (!isPdfExport || !i || !setGridExportCallbacks) {
      return;
    }
    setGridExportCallbacks((cbs) => [
      ...cbs.filter((cb) => cb.cardI !== i),
      { cardI: i, callback: exportDataAsCsv },
    ]);
    return () => {
      setGridExportCallbacks((cbs) => cbs.filter((cb) => cb.cardI !== i));
    };
  }, [isPdfExport, i, setGridExportCallbacks, exportDataAsCsv]);

  return null;
};

export default GridCsvExportRegistrar;
